/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageprevious2Inputs */

const en_ticketpageprevious2 = /** @type {(inputs: Ticketpageprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const de_ticketpageprevious2 = /** @type {(inputs: Ticketpageprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Ticketpageprevious2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageprevious2 = /** @type {((inputs?: Ticketpageprevious2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageprevious2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageprevious2(inputs)
	return de_ticketpageprevious2(inputs)
});
export { ticketpageprevious2 as "ticketPagePrevious" }